import React from "react";
import "./Footer.css";
import Footer_logo from "../../assests/Frame 185060.png";
import Google_store from "../../assests/playstore.png";
import App_store from "../../assests/applestore.png";
import { Link } from "react-router-dom";
import { Link as ScrollLink } from "react-scroll";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-inner">
        {/* Top grid */}
        <div className="footer-grid">
          {/* Brand col */}
          <div className="footer-brand">
            <Link to="/">
              <img src={Footer_logo} alt="Sendcheap" className="footer-logo" />
            </Link>
            <p className="footer-tagline">
              Nigeria's all-in-one payment platform. Bank transfers, bill
              payments, and crypto — online or offline.
            </p>
            <div className="footer-stores">
              <a
                href="https://apps.apple.com/ng/app/sendcheap/id6448403237"
                target="_blank"
                rel="noreferrer"
              >
                <img src={App_store} alt="App Store" className="footer-store" />
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=com.sendcheap.sendcheap&hl=en"
                target="_blank"
                rel="noreferrer"
              >
                <img src={Google_store} alt="Google Play" className="footer-store" />
              </a>
            </div>
          </div>

          {/* Product links */}
          <div className="footer-col">
            <h4 className="footer-col-title">Product</h4>
            <ul className="footer-links">
              <li>
                <a href="#services" onClick={(e) => {
                  e.preventDefault();
                  document.getElementById("services")?.scrollIntoView({ behavior: "smooth" });
                }}>
                  Features
                </a>
              </li>
              <li><Link to="/apis">APIs</Link></li>
              <li>
                <a href="https://onelink.to/n9hyxn" target="_blank" rel="noreferrer">
                  Download App
                </a>
              </li>
            </ul>
          </div>

          {/* Company links */}
          <div className="footer-col">
            <h4 className="footer-col-title">Company</h4>
            <ul className="footer-links">
              <li><Link to="/contact">Contact</Link></li>
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
              <li><Link to="/privacy-policy">Terms of Service</Link></li>
            </ul>
          </div>

          {/* Services links */}
          <div className="footer-col">
            <h4 className="footer-col-title">Services</h4>
            <ul className="footer-links">
              <li><span>Bank Transfer</span></li>
              <li><span>Airtime &amp; Data</span></li>
              <li><span>Bill Payments</span></li>
              <li><span>Crypto Exchange</span></li>
            </ul>
          </div>
        </div>

        <div className="footer-divider"></div>

        {/* Bottom row */}
        <div className="footer-bottom">
          <p className="footer-copy">
            &copy; {new Date().getFullYear()} Sendcheap Limited. All rights reserved.
          </p>
          <div className="footer-socials">
            <a href="https://x.com/sendcheap_Ltd?t=udHylxjoUok31nLRwzAE3g&s=09" target="_blank" rel="noreferrer" className="footer-social-link">
              X (Twitter)
            </a>
            <a href="https://www.instagram.com/reel/DXyqOWvsRGB/" target="_blank" rel="noreferrer" className="footer-social-link">Instagram</a>
            <a href="#" className="footer-social-link">LinkedIn</a>
            <a href="https://web.facebook.com/sendcheap/" target="_blank" rel="noreferrer" className="footer-social-link">Facebook</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
